import { useEffect } from "react";
import { useSelector, shallowEqual } from "react-redux";
import { useTranslation } from "react-i18next";
import { FormControl, FormLabel } from "@mui/material";
import { Box } from "@mui/system";
import { RootState } from "@app/store";
import SortTable, { IProperty } from "@features/common/Table/SortTable";
import { selectVnets, selectVnet } from "./subnetsSlice";
import { useAppDispatch } from "@features/common/StoreHook";
import CloudPlatformChip from "@features/common/CloudPlatformChip";
import { formControlStyle, formLabelStyle } from "../style";

const VNet = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();

  const vnets = useSelector(
    (state: RootState) => selectVnets(state),
    shallowEqual,
  );
  const selectedVnet = useSelector((state: any) => state.subnets.selectedVnet);
  const isLoading =
    useSelector((state: any) => state.subnets.status) === "loading";

  useEffect(() => {
    if (vnets.length > 0 && !selectedVnet) {
      dispatch(selectVnet(vnets[0].vnet_name));
    }
  }, [vnets, selectedVnet, dispatch]);

  const handleSelectItem = (id: string) => {
    dispatch(selectVnet(id));
  };

  const properties: IProperty<any>[] = [
    { key: "vnet_name", label: t("label-name") },
    { key: "cloudPlatform", label: t("label-cloud-platform") },
  ];

  const vnetsArr = vnets.map((vnet: any) => ({
    vnet_name: vnet.vnet_name,
    cloudPlatform: <CloudPlatformChip cloudPlatform={vnet.cloud_platform} />,
  }));

  return (
    <Box>
      <FormControl component="fieldset" sx={formControlStyle}>
        <FormLabel component="legend" sx={formLabelStyle}>
          {t("label-virtual-networks")}
        </FormLabel>
        <SortTable
          properties={properties}
          idProperty={"vnet_name"}
          handleChange={handleSelectItem}
          isLoading={isLoading}
          selectedId={selectedVnet || ""}
          data={vnetsArr}
        />
      </FormControl>
    </Box>
  );
};

export default VNet;
